export default __webpack_public_path__ + "static/attic-108c32ef8f81e525e22c3f7e9eb3c015.svg";